export default __webpack_public_path__ + "static/media/Birds_on_a_love_wire.67ae845d.jpg";